import React, { useState } from 'react';
import { Layout, Menu, Input, Button, Avatar, Dropdown } from 'antd';
import { 
  SearchOutlined, 
  UserOutlined, 
  EditOutlined,
  LogoutOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './index.css';

const { Header: AntHeader } = Layout;
const { Search } = Input;

const Header = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // 根据当前路径设置选中的菜单项
  const getCurrentMenuKey = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/archive') return 'archive';
    if (path === '/write' || path.startsWith('/write/')) return 'write';
    if (path === '/about') return 'about';
    return 'home';
  };
  
  const currentMenu = getCurrentMenuKey();
  
  const handleMenuClick = (e) => {
    // 这里可以添加菜单点击的额外处理逻辑
  };
  
  const handleSearch = (value) => {
    if (value.trim()) {
      navigate(`/search?q=${encodeURIComponent(value)}`);
    }
  };
  
  const handleLogin = () => {
    navigate('/auth');
  };
  
 const userMenuItems = [
  {
    key: 'profile',
    icon: <UserOutlined />,
    label: <Link to="/about">个人中心</Link>,
  },
  {
    key: 'write',
    icon: <EditOutlined />,
    label: <Link to="/write">写文章</Link>,
  },
  {
    type: 'divider',
  },
  {
    key: 'logout',
    icon: <LogoutOutlined />,
    label: <a onClick={onLogout}>退出登录</a>,
  },
];
  
  return (
    <AntHeader className="blog-header">
      <div className="header-container">
        {/* Logo 和标题 */}
        <div className="header-left">
          <Link to="/" className="logo">
            <h1>我的博客</h1>
          </Link>
          <span className="slogan">记录生活点滴，分享技术思考</span>
        </div>
        
        {/* 导航菜单 */}
        <div className="header-center">
          <Menu
            mode="horizontal"
            selectedKeys={[currentMenu]}
            onClick={handleMenuClick}
            className="main-menu"
          >
            <Menu.Item key="home">
              <Link to="/">首页</Link>
            </Menu.Item>
            <Menu.Item key="archive">
              <Link to="/archive">归档</Link>
            </Menu.Item>
            <Menu.Item key="write">
              <Link to="/write">写文章</Link>
            </Menu.Item>
            <Menu.Item key="about">
              <Link to="/about">关于我</Link>
            </Menu.Item>
          </Menu>
        </div>
        
        {/* 搜索框和用户操作 */}
        <div className="header-right">
          <Search
            placeholder="搜索文章标题、内容或标签"
            onSearch={handleSearch}
            enterButton={<SearchOutlined />}
            className="header-search"
            style={{ width: 200 }}
          />
          
          {user ? (
            <div className="user-info-section">
              <span className="welcome-text">
                欢迎，{user.username}
              </span>
              <Dropdown 
                menu={{ items: userMenuItems }} 
                placement="bottomRight"
                trigger={['click']}
              >
                <div className="avatar-dropdown-trigger">
                  <Avatar 
                    icon={!user.avatar && <UserOutlined />}
                    src={user.avatar}
                    className="user-avatar-small"
                    size="samll"
                  />
                </div>
              </Dropdown>
            </div>
          ) : (
            <Button 
              type="primary" 
              onClick={handleLogin}
              className="login-btn"
            >
              登录/注册
            </Button>
          )}
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;